import { Breadcrumb } from "antd";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDashboardCustomize, MdTableRows } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchCourseById
} from "../../../../../reduxToolkit/Course/coursesSpecSlice";
import CLOsListView from "./CLOsListView";
import CourseSpecClosList from "./CourseSpecClosList";

export default function CLOs({ match }) {
  const { id } = match.params;

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [disabledStatus, setDisabledStatus] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");
  const [view, setView] = useState("card")

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const fetchCourseByIdMethod = async () => {
    try {
      const resultAction = await dispatch(fetchCourseById(id))
        .unwrap()
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  useEffect(() => {
    fetchCourseByIdMethod();
    if (localStorage.getItem("CourseState") != "Draft") {
      setDisabledStatus(true);
    }
  }, [dispatch]);

  const course = useSelector((state) => state.CourseSpec.courseSpecification);

  return (

    <div>
      <GridContainer justify="space-between" alignItems="baseline">
        <GridItem>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>
              <Link to={`/citrine/CourseSpecificationList/`}>
                {t("Courses List")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/courseSpecDetails/${id}`}>
                {course && course.title && course.title}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/courses/${id}/clos`}
              >
                {t("Clos List")}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>

        <GridItem>
          <Button
            color={view === "list" ? "primary" : "transparent"}
            // simple
            justIcon
            onClick={() => setView("list")}
          >
            <MdTableRows />
          </Button>

          <Button
            color={view === "card" ? "primary" : "transparent"}
            // simple
            justIcon
            onClick={() => setView("card")}
          >
            <MdDashboardCustomize />
          </Button>
        </GridItem>
      </GridContainer>
      {view === "card" && <div><CourseSpecClosList id={id} /></div>}
      {view === "list" && <div><CLOsListView id={id} clos={course && course.closSpec} /></div>}
    </div >
  )

}
